import React from 'react';
import styled from 'styled-components';
import TopNavbar from '../../Nav/TopNavbar';
import Footer from '../Footer';

import { useTranslation } from 'react-i18next';
import ShareSidebar from './ShareSidebar';
import { Helmet } from 'react-helmet';

const BlogModelPricingCITRIN = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('blog.titlePricingCITRIN')}</title>
                <meta property="og:title" content={t('blog.titlePricingCITRIN')} />
                <meta property="og:image" content={require('../../../assets/img/familyInCar.jpg')} />
                <meta property="og:description" content={t('blog.intro.pricingCitrin1')} />
            </Helmet>

            <ShareSidebar
                title={t('blog.titlePricingCITRIN')}
                media={require('../../../assets/img/WomanIntheCar.jpg')}
                url={`https://citrin-mobility.com/blog/citrin-dynamic-pricing`}
                hashtags={['#citrin', '#mobility', '#transport']}
            />

            <TopNavbar />
            <Wrapper id="citrin-dynamic-pricing">
                <Container>
                    <Meta>{t('blog.metaPricingCITRIN')}</Meta>
                    <Title>{t('blog.titlePricingCITRIN')}</Title>
                    <ImgWrapperTitle>
                        <img src={require('../../../assets/img/familyInCar.jpg')} alt="family in the car" />
                    </ImgWrapperTitle>

                    <Intro>
                        <p>{t('blog.intro.pricingCitrin1')}</p>
                        <p>{t('blog.intro.pricingCitrin2')}</p>
                    </Intro>

                    <Section>
                        <h2>{t('blog.howPricingWorks.title')}</h2>
                        <p>{t('blog.howPricingWorks.description')}</p>
                        <ImgWrapper>
                            <img src={require('../../../assets/img/womanManCar.jpg')} alt="Man in the taxi" />
                        </ImgWrapper>
                    </Section>
                    <Section>
                        <h2>{t('blog.peakHours.title')}</h2>
                        <p>{t('blog.peakHours.description')}</p>
                        <Checklist>
                            <li>{t('blog.peakHours.item1')}</li>
                            <li>{t('blog.peakHours.item2')}</li>
                            <li>{t('blog.peakHours.item3')}</li>
                        </Checklist>
                        <h4>{t('blog.promo.closing')}</h4>
                    </Section>

                    <Section>
                        <p className="font15 greyColor font20">
                            <em>{t('blog.postedBy')}</em>
                        </p>
                    </Section>
                </Container>
            </Wrapper>
            <Footer />
        </>
    );
};
export default BlogModelPricingCITRIN;

// -------------------- STYLED COMPONENTS --------------------

const Wrapper = styled.section`
    background: #fff;
    padding: 60px 0;

    @media (max-width: 600px) {
        padding: 40px 12px;
    }
`;

const Container = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 0 24px;

    @media (max-width: 600px) {
        padding: 0 12px;
    }
`;

const Meta = styled.p`
    font-size: 14px;
    color: #666;
    margin-bottom: 32px;
    text-align: center;

    @media (max-width: 600px) {
        margin-bottom: 20px;
    }
`;

const ImgWrapperTitle = styled.div`
    width: 100vw;
    margin: 32px calc(-50vw + 50%);
    display: flex;
    justify-content: center;

    img {
        width: 1000px;
        max-width: 100%;
        height: 480px;
        object-fit: cover;
        border-radius: 12px;

        @media (max-width: 600px) {
            height: auto;
            width: 100%;
            border-radius: 8px;
        }
    }
`;

const Title = styled.h1`
    font-size: 44px;
    font-weight: 700;
    margin-bottom: 8px;
    color: #000;

    @media (max-width: 600px) {
        font-size: 28px;
        text-align: center;
    }
`;

const Intro = styled.div`
    font-size: 17px;
    color: #333;
    line-height: 1.7;
    margin-bottom: 40px;

    p {
        margin-bottom: 20px;
    }

    @media (max-width: 600px) {
        font-size: 15px;
        margin-bottom: 30px;
    }
`;

const Section = styled.section`
    margin-bottom: 48px;

    h2 {
        font-size: 25px;
        font-weight: 600;
        margin-bottom: 16px;
        color: #111;

        @media (max-width: 600px) {
            font-size: 20px;
        }
    }

    p {
        font-size: 16px;
        color: #444;
        line-height: 1.7;
        margin-bottom: 16px;

        @media (max-width: 600px) {
            font-size: 14px;
        }
    }
`;

const Checklist = styled.ol`
    list-style-type: disc;
    padding-left: 1.5em;
    margin-top: 16px;

    li {
        margin-bottom: 12px;
        font-size: 16px;
        color: #333;
        line-height: 1.7;

        @media (max-width: 600px) {
            font-size: 14px;
            margin-bottom: 10px;
        }
    }

    ul {
        list-style-type: circle;
        padding-left: 1.5em;
        margin-top: 8px;
    }

    ul li {
        margin-bottom: 8px;
        font-size: 16px;

        @media (max-width: 600px) {
            font-size: 14px;
        }
    }
`;

const ImgWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 32px 0;

    img {
        width: 1000px;
        max-width: 100%;
        height: 480px;
        border-radius: 12px;

        @media (max-width: 600px) {
            height: auto;
            width: 100%;
            border-radius: 8px;
        }
    }
`;

const TipBlock = styled.div`
    background-color: #f4f8fb;
    border-left: 5px solid #0077cc;
    padding: 16px;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 1.7;
    color: #333;
    border-radius: 6px;

    strong {
        display: block;
        margin-bottom: 8px;
        color: #000;
    }

    @media (max-width: 600px) {
        font-size: 14px;
        padding: 12px;
        margin-bottom: 20px;
    }
`;
const NumberedChecklist = styled.ol`
    padding-left: 1.2rem;

    li {
        margin-bottom: 0.75rem;
        font-size: 1rem;
        line-height: 1.6;
    }

    .number {
        font-weight: bold;
        margin-right: 0.4rem;
    }

    ul {
        margin-top: 0.5rem;
        margin-left: 1.5rem;
        list-style-type: disc;

        li {
            font-weight: normal;
            font-size: 0.95rem;
            margin-bottom: 0.3rem;
        }
    }
`;
